import { TemplatePageProps } from './types'
import { BlockolotEntity } from './entity'
import Icon from 'images/games/blockolot/icon.png'
import Swiper1 from 'images/games/blockolot/swiper1.webp'
import Swiper2 from 'images/games/blockolot/swiper2.webp'
import Swiper3 from 'images/games/blockolot/swiper3.webp'
import Swiper4 from 'images/games/blockolot/swiper4.webp'
import Swiper5 from 'images/games/blockolot/swiper5.webp'
import Swiper6 from 'images/games/blockolot/swiper6.webp'
import Swiper7 from 'images/games/blockolot/swiper7.webp'
import Detail1 from 'images/games/blockolot/detail1.png'
import Detail2 from 'images/games/blockolot/detail2.png'
import Detail3 from 'images/games/blockolot/detail3.png'
import Footer from 'images/games/blockolot/footer.png'
import {
  BingoClashLink,
  BingoTourLink,
  BubbleBuzzLink,
  EightBallStrikeLink,
  GamesLink,
  SolitaireClashLink,
} from '../../components'

export const BlockolotDetail: TemplatePageProps = {
  entity: {
    ...BlockolotEntity,
    logo: Icon,
    title: <>Blockolot: Classic Block Puzzle Game Reimagined</>,
    description: (
      <>
        Dive into a neon-lit puzzle frenzy with Blockolot! This fast-paced <strong>block puzzle</strong> transforms{' '}
        <strong>classic Tetris</strong> into a thrilling race against time. Think fast, clear rows, and have the
        opportunity to win cash when you rack up the highest points. Download now from the App Store, Galaxy Store, or
        Android APK!
      </>
    ),
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
    { image: Swiper7 },
  ],
  content: [
    {
      title: <>Blasting Blocks: How To Play Blockolot</>,
      description: (
        <>
          In this block-blasting game, strategically place blocks on the grid within the time limit, clearing lines to
          earn points and make space for more blocks. The goal is to score big by creating combos with back-to-back
          clears or multiple lines in a single move. Keep an eye out for Star Blocks to earn cash rewards and outscore
          your opponents for even bigger prizes. Practice your skills in <strong>free block games</strong> using gems
          before entering cash matches. With tight grids and limited time, every move counts—so plan ahead, pack the
          board wisely, and think fast to come out on top!
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Clearing Blocks for Real Cash</>,
      description: (
        <>
          Blockolot takes <strong>block puzzle online</strong> to the next level by adding a skill-based, real money
          twist! Compete in multiplayer tournaments against players of similar skill, ensuring a fair and exciting
          challenge. Every move you make could lead to cash rewards using faster, smarter, and more strategic gameplay.
          Whether clearing rows or executing combos, your puzzle-solving skills will be put to the test. Global
          matchmaking connects you with players worldwide, fueling a competitive environment. Ready to show off your
          skills and win real cash? Play now and start earning!
        </>
      ),
      image: Detail2,
    },
    {
      title: <>Stack Your Winnings: Secure Payment Methods</>,
      description: (
        <>
          When it’s time to cash out your winnings, Blockolot ensures a smooth, secure process! Withdraw safely through
          PayPal for quick, reliable payments. Deposit easily using options like PayPal, Venmo, Apple Pay, Visa,
          Mastercard, Amex, or Discover. All transactions are protected with top-level security, so you can focus on
          your <strong>block puzzle game</strong> without worry. Whether you’re adding funds or cashing out, Blockolot
          makes it simple and stress-free. Start playing today and stack your rewards with confidence!
        </>
      ),
      image: Detail3,
    },
    {
      title: <>Keep the Blast Going: Explore More Games!</>,
      description: (
        <>
          Enjoyed playing <strong>block puzzle games</strong> in Blockolot? Dive into other exciting{' '}
          <GamesLink>strategy games</GamesLink> from Avia! Stack cards and beat the clock in <SolitaireClashLink />,
          achieve &#34;Full House!&#34; in the frenzy of <BingoClashLink /> and <BingoTourLink />, test your aim in{' '}
          <EightBallStrikeLink />, or pop your way to victory in <BubbleBuzzLink /> for more opportunities to win cash.
          No matter your skill and preference, Avia offers a variety of thrilling games that let you test your skills
          and earn real rewards. Ready for your next adventure? Download now and start playing today!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
} as TemplatePageProps
